import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ad1',
  templateUrl: './ad1.component.html',
  styleUrls: ['./ad1.component.css']
})
export class Ad1Component implements OnInit {

  firstAdForm: FormGroup = new FormGroup({ 
    iam: new FormControl('', [Validators.required]),
    listingFor: new FormControl('', [Validators.required]),
    property_type_id: new FormControl(null, [Validators.required])
  })

  propertyTypes = []

  @Output() stepChangeEvent = new EventEmitter<string>();

  constructor( private route: ActivatedRoute ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: { propertyTypes: any }) =>{
      this.propertyTypes = data.propertyTypes
    })
  }

  next(){
    this.stepChangeEvent.emit('step-2');
  }

}
